import { Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ICompany, IExtendedDocument, IExtendedWindow, IWebshop } from '../../../../type_definitions/datatypes';
import { UserDataService } from '../../../shared/user/user-data.service';
import { CompanyDataService } from '../../../shared/company/company-data.service';
import { WebshopDataService } from '../../webshop/webshop-data.service';
import { FormattingService } from '../../../shared/services/formatting.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { DOCUMENT } from '@angular/common';

interface ISignupManagementModel {
  company?:ICompany;
  webshop?:IWebshop;
  signupLink?:string;
}

@Component({
  selector: 'management-signup',
  template: `
    <h2>Signup Management</h2>

    <div class="row">
      <div class="col-md-6">
        <formly [fields]="fields" [model]="model" [form]="form"></formly>
        <button class="btn btn-primary float-end" (click)="createLink()" [busyButton]="creating">Create signup link</button>
      </div>
    </div>
  `
})
export class SignupManagementComponent {
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public model:ISignupManagementModel = {};
  public fields:IExtraFieldConfigurationObject[];
  public creating:boolean;

  private companyField:IExtraFieldConfigurationObject;
  private webshopField:IExtraFieldConfigurationObject;

  constructor(
    private userDataService:UserDataService,
    private companyDataService:CompanyDataService,
    private webshopDataService:WebshopDataService,
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    private validateService:GaValidateService,
    @Inject(Window) private window:IExtendedWindow,
    @Inject(DOCUMENT) private document:IExtendedDocument
  ) {
    this.createFields();
    this.fillFields();
  }

  public createLink():void {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.creating = true;
        return this.userDataService.createSignupLink(this.model.company && this.model.company.id, undefined, this.model.webshop && this.model.webshop.id);
      })
      .then((link:string) => {
        this.form.get('signupLink')?.patchValue(link);
        this.window.getSelection()?.selectAllChildren(
          this.document.querySelectorAll('.signup-link')[ 0 ]
        );
      })
      .finally(() => {
        this.creating = false;
      });
  }

  private createFields() {
    this.companyField = this.formlyService.aSelect('company', 'Company')
      .withFormat(this.formattingService.formatCompany)
      .isRequired()
      .build();

    this.webshopField = this.formlyService.aSelect('webshop', 'Webshop')
      .withFormat(this.formattingService.formatCompany)
      .build();

    this.fields = [
      this.formlyService.aTitle('Create customer signup link')
        .build(),
      this.companyField,
      this.webshopField,
      this.formlyService.aValue('signupLink', 'Signup link')
        .withValueClass('signup-link col-sm-9')
        .build()
    ];
  }

  private fillFields():void {
    this.formlyService.fillField(this.companyField, this.companyDataService.customerCompanies());
    this.formlyService.fillField(this.webshopField, this.webshopDataService.webshops());
  }
}